import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/components/Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer" role="contentinfo" aria-label="Site footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-logo">
            <img 
              src={require('../assets/images/RushHour_logo_v2.png')} 
              alt="RushHour Logo" 
              className="footer-logo-img" 
            />
            <span className="footer-logo-text">RushHour</span>
          </div>
          <nav className="footer-links" aria-label="Footer navigation">
            <Link to="/terms" className="footer-link">Terms & Conditions</Link>
            <Link to="/privacy" className="footer-link">Privacy Policy</Link>
            <Link to="/support" className="footer-link">Support</Link>
          </nav>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 RushHour. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
